export const KEYS = Object.freeze({
    GOOGLE_RECAPTCHA_SITEKEY: '6LdzAq8UAAAAABBbUw1RrooUxXvAphjRn_dAnpmx'
  })